import { render, staticRenderFns } from "./CommentTextFormTextArea.vue?vue&type=template&id=338db1b6&"
import script from "./CommentTextFormTextArea.vue?vue&type=script&lang=ts&"
export * from "./CommentTextFormTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./CommentTextFormTextArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
